module.exports = "<div class=\"breadcrumbs\">\n    <div class=\"breadcrumbs-container\" [ngClass]=\"{ projectEnvs: isInProjects() }\">\n        <span *ngIf=\"canGoBack()\" class=\"breadcrumb-location back-button dbm\" (click)=\"backClicked()\">&lt;</span>\n        <span *ngFor=\"let location of locationMap; let first = first\" class=\"breadcrumb-location\">\n            <span *ngIf=\"!first\" class=\"separator\">/</span>\n            <a href=\"#\" (click)=\"navigate($event, location)\">{{location.name}}</a>\n        </span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/breadcrumbs/breadcrumbs.component.html
// module id = 1723
// module chunks = 0